import ReactGA from "react-ga4";
import CustomButton from "../../../components/common/CustomButton";

const HeroSection = () => {

  const handleBookClick = () =>{
    window.location.href = "/book-a-demo"
  }

  const handleVideoClick = () =>{
    ReactGA.initialize("G-ZB9N7T58NE");
    ReactGA.event({
      category: 'User',
      action: 'Clicked: Watch video '
    });
  }

  return (
    <div className={`relative isolate`} >
      <div className="flex flex-col md:flex-row mt-12 md:mt-20 h-full px-20 xs:px-5 gap-5 xs:mb-10" >
        <div className="flex-1 flex flex-col xs:items-center justify-center px-10 xs:px-5 xs:mb-10">
          <div className=" max-w-3xl text-4xl md:text-5xl lg:text-6xl text-center md:text-start font-extrabold leading-2 text-white  mb-6 font-sans capitalize">
            Your AI Project Planning Agent.
          </div>
          <div className="max-w-xl text-md text-center md:text-start leading-normal text-gray-400 lg:text-xl mb-8 font-sans">
            Cadencepro sees what your PM tools can’t. While PM tools manage tasks, Cadencepro manages project execution risk.
          </div>

          <div className="flex items-center justify-center gap-5 md:pr-24 xs:pr-0 box-content">
            <CustomButton
              onClick={handleBookClick}
              className="whitespace-nowrap bg-primary-light hover:bg-primary-hover  px-5 py-3 shadow-sm hover:shadow-md transition-all
                  duration-200 text-white md:!w-full !rounded-full font-semibold font-['Work Sans'] text-lg xs:text-xs"
            >
              <span>Book a demo</span>
            </CustomButton>
          </div>
        </div>
        <div className="flex-1 md:flex-2">
          <div className="group rounded-lg px-2 xs:px-6 flex items-center py-4 h-full relative" >
            <video
              className="min-w-full rounded-xl"
              controls
              playsInline
              preload="metadata"
              poster="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/videoThumbnail.png"
              onClick={handleVideoClick}
            >
              <source src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/documents/cadanceprovideo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection;